/* IC OWL POPUP v1.1 — + heartbeat pulse animation (la fiecare ~6 sec) */
(function() {
  'use strict';

  var css = '.ic-owl-popup{position:fixed;z-index:9998;opacity:0;transform:translateY(8px) scale(0.95);transition:opacity .35s ease,transform .4s cubic-bezier(0.34,1.56,0.64,1);pointer-events:none;}' +
    '.ic-owl-popup.is-visible{opacity:1;transform:translateY(0) scale(1);pointer-events:auto;}' +
    '.ic-owl-popup__bubble{position:relative;background:#F5F0E8;border:2px solid #C9A96E;border-radius:14px;padding:16px 28px 16px 18px;max-width:260px;box-shadow:0 10px 28px rgba(26,22,18,0.18),0 2px 6px rgba(26,22,18,0.08);font-family:Lato,system-ui,sans-serif;color:#1A1612;transform-origin:bottom right;}' +
    /* Heartbeat pulse — doar dupa ce popup-ul devine vizibil */
    '@keyframes ic-owl-heartbeat{' +
      '0%,92%,100%{transform:scale(1);box-shadow:0 10px 28px rgba(26,22,18,0.18),0 2px 6px rgba(26,22,18,0.08);}' +
      '3%{transform:scale(1.035);box-shadow:0 16px 38px rgba(26,22,18,0.24),0 4px 12px rgba(201,169,110,0.18);}' +
      '6%{transform:scale(1);box-shadow:0 10px 28px rgba(26,22,18,0.18),0 2px 6px rgba(26,22,18,0.08);}' +
    '}' +
    '.ic-owl-popup.is-visible .ic-owl-popup__bubble{animation:ic-owl-heartbeat 6s ease-in-out 5s infinite;}' +
    /* Bubble tail (sageata in jos catre bufnita) */
    '.ic-owl-popup__bubble::after{content:"";position:absolute;bottom:-12px;right:30px;width:0;height:0;border-left:11px solid transparent;border-right:11px solid transparent;border-top:11px solid #C9A96E;}' +
    '.ic-owl-popup__bubble::before{content:"";position:absolute;bottom:-9px;right:33px;width:0;height:0;border-left:8px solid transparent;border-right:8px solid transparent;border-top:8px solid #F5F0E8;z-index:1;}' +
    /* Text */
    '.ic-owl-popup__title{font-family:"Lora",Georgia,serif;font-style:italic;font-weight:500;font-size:24px;line-height:1.1;color:#1A1612;margin:0 0 6px;letter-spacing:-0.01em;}' +
    '.ic-owl-popup__body{font-size:13px;line-height:1.5;color:rgba(26,22,18,0.82);margin:0 0 10px;}' +
    '.ic-owl-popup__cta{display:inline-block;font-size:12px;font-weight:700;letter-spacing:0.04em;color:#C9A96E;text-decoration:none;border-bottom:1px solid #C9A96E;padding-bottom:1px;transition:color .2s,border-color .2s;}' +
    '.ic-owl-popup__cta:hover{color:#1A1612;border-bottom-color:#1A1612;}' +
    '.ic-owl-popup__close{position:absolute;top:4px;right:6px;background:none;border:none;font-size:20px;line-height:1;color:rgba(26,22,18,0.4);cursor:pointer;padding:4px 8px;font-family:inherit;transition:color .2s;z-index:2;}' +
    '.ic-owl-popup__close:hover{color:#1A1612;}' +
    /* Pauza pulse pe hover (politicos cu utilizatorul care vrea sa citeasca) */
    '.ic-owl-popup:hover .ic-owl-popup__bubble{animation-play-state:paused;}' +
    /* Respect prefers-reduced-motion */
    '@media(prefers-reduced-motion:reduce){' +
      '.ic-owl-popup.is-visible .ic-owl-popup__bubble{animation:none;}' +
      '.ic-owl-popup{transition:opacity .25s ease;transform:none;}' +
    '}' +
    '@media(max-width:640px){.ic-owl-popup__bubble{max-width:220px;padding:14px 28px 14px 16px;}.ic-owl-popup__title{font-size:21px;}.ic-owl-popup__body{font-size:12.5px;}}';

  var styleEl = document.createElement('style');
  styleEl.id = 'ic-owl-popup-style';
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  function initOwlPopup() {
    var path = location.pathname || '/';
    if (path !== '/' && path !== '/en' && path !== '/en/') return;

    try {
      if (localStorage.getItem('ic_owl_popup_dismissed_v1') === '1') return;
    } catch (e) {}

    var attempts = 0;
    function tryRender() {
      attempts++;
      var owl = document.querySelector('.ic-owl-fab');
      if (!owl) {
        if (attempts < 20) setTimeout(tryRender, 500);
        return;
      }
      if (document.getElementById('ic-owl-popup')) return;

      var popup = document.createElement('div');
      popup.id = 'ic-owl-popup';
      popup.className = 'ic-owl-popup';
      popup.innerHTML =
        '<div class="ic-owl-popup__bubble">' +
          '<button class="ic-owl-popup__close" type="button" aria-label="Închide">×</button>' +
          '<div class="ic-owl-popup__title">psssst…</div>' +
          '<div class="ic-owl-popup__body">Cauți rețeta perfectă pentru cafeaua ta? Sunt aici, dedesubt. Apasă-mă.</div>' +
          '<a href="/pages/calculator" class="ic-owl-popup__cta">Folosește calculatorul →</a>' +
        '</div>';
      document.body.appendChild(popup);

      function positionPopup() {
        var rect = owl.getBoundingClientRect();
        var right = Math.max(8, window.innerWidth - rect.right);
        var bottom = Math.max(8, window.innerHeight - rect.top + 16);
        popup.style.right = right + 'px';
        popup.style.bottom = bottom + 'px';
      }
      positionPopup();
      window.addEventListener('resize', positionPopup);
      window.addEventListener('scroll', positionPopup);

      var showTimer = setTimeout(function() {
        popup.classList.add('is-visible');
        positionPopup();
      }, 4000);

      function dismiss(persist) {
        popup.classList.remove('is-visible');
        setTimeout(function() {
          if (popup.parentNode) popup.parentNode.removeChild(popup);
        }, 400);
        if (persist) {
          try { localStorage.setItem('ic_owl_popup_dismissed_v1', '1'); } catch (e) {}
        }
      }

      popup.querySelector('.ic-owl-popup__close').addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        clearTimeout(showTimer);
        dismiss(true);
      });

      popup.querySelector('.ic-owl-popup__cta').addEventListener('click', function() {
        try { localStorage.setItem('ic_owl_popup_dismissed_v1', '1'); } catch (e) {}
      });

      setTimeout(function() {
        if (popup.parentNode) dismiss(false);
      }, 28000);
    }

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      setTimeout(tryRender, 200);
    } else {
      document.addEventListener('DOMContentLoaded', function() { setTimeout(tryRender, 200); });
    }
  }

  initOwlPopup();
})();
